import { render, staticRenderFns } from "./DictionariesEdit.vue?vue&type=template&id=55293b3b&scoped=true&"
import script from "./DictionariesEdit.vue?vue&type=script&lang=js&"
export * from "./DictionariesEdit.vue?vue&type=script&lang=js&"
import style0 from "./DictionariesEdit.vue?vue&type=style&index=0&id=55293b3b&lang=scss&scoped=true&"
import style1 from "./DictionariesEdit.vue?vue&type=style&index=1&id=55293b3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55293b3b",
  null
  
)

export default component.exports